export const name = "ST_TOUCHES";
export const summary = `Checks if two \`GEOGRAPHY\` values intersect and their interiors have no elements in common.`;
export const reference = `
## ST_TOUCHES

Checks if two \`GEOGRAPHY\` values intersect and their interiors have no elements in common.

\`\`\`
ST_TOUCHES(geography_1, geography_2)
\`\`\`

### Description

Returns \`TRUE\` provided the following two conditions are satisfied:

1. \`geography_1\` intersects \`geography_2\`.
2. The interior of \`geography_1\` and the interior of \`geography_2\` are disjoint.


### Return type

\`BOOL\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
